import { createContext, useContext, useMemo, useState } from "react";

import PropTypes from 'prop-types';

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {

    const [showAdminMenu, setShowAdminMenu] = useState(() => {
        const saved = localStorage.getItem("showAdminMenu");
        return saved ? JSON.parse(saved) : false; // parse boolean correctly
    });

    const toggleAdminMenu = (newValue) => {

        setShowAdminMenu((prev) => {
            const newState = typeof newValue === "boolean" ? newValue : !prev;

            localStorage.setItem("showAdminMenu", JSON.stringify(newState));
            return newState;
        });
    };

    const value = useMemo(() => ({ showAdminMenu, toggleAdminMenu }), [showAdminMenu]);

    return (
        <MenuContext.Provider value={value}>
            {children}
        </MenuContext.Provider>
    );
};

MenuProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

// Custom hook for easier consumption
export const useMenu = () => useContext(MenuContext);
